document.querySelectorAll('[data-tab]').forEach(item => item.addEventListener('click', function () {
    if (this.classList.contains('active'))
        return;

    document.querySelectorAll('[data-tab], [data-tab-content]').forEach(item => item.classList.remove('active'));
    this.classList.add('active');

    const id = this.getAttribute('data-tab');
    const tab_content_el = document.querySelector(`[data-tab-content="${id}"]`);
    tab_content_el.classList.add('active');

    if (tab_content_el) {
        const offset = window.innerWidth <= 1199 ? 80 : 100;
        const elementPosition = tab_content_el.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
}))
